import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { map, take } from "rxjs/operators";
import { Observable } from "rxjs";
import { UserMessageFacade } from "../domain/+state/user-message.facade";
import { USER_MESSAGE_RETURN_URL_STORAGE_KEY, UserMessageData } from "../domain/models/user-message.model";

@Injectable({
  providedIn: "root",
})
export class UserMessageGuard implements CanActivate {
  constructor(
    private router: Router,
    private facade: UserMessageFacade,
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.facade.getNewPopupMessages().pipe(
      take(1),
      map((messages: UserMessageData[]) => this.validate(messages, state.url))
    );
  }

  private validate(messages: UserMessageData[], returnUrl: string): boolean {
    if (messages.length > 0) {
      sessionStorage.setItem(USER_MESSAGE_RETURN_URL_STORAGE_KEY, returnUrl);
      this.router.navigate(["messages"], {
        replaceUrl: true,
        queryParamsHandling: "preserve",
      });
      return false;
    }

    return true;
  }
}
